// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3920":"3a562b87","4915":"7f6f3c2c","6832":"3a562b87","8491":"2070c431","8976":"34f0f20a"}[chunkId] + ".chunk.css";
};